import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Componente que protege las rutas que requieren autenticación.
 * Si el usuario no está autenticado, lo redirige a la página de login (/).
 */
function ProtectedRoutes({ allowedRoles }) {
  const { isAuthenticated, role } = useAuth();
    
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/home" replace />;
  }

  // Si está autenticado, renderiza las rutas hijas
  return <Outlet />;
}

export default ProtectedRoutes;
